/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { shape, object, string } from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { uid } from 'react-uid';
import { useAuth } from '../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';
import PassportLanderCta from './PassportLanderCta';
import resolvePassportCopy from './resolvePassportCopy';

const useStyles = makeStyles(() => ({
    hero: {
        boxSizing: 'border-box',
        minHeight: 1100,
        padding: '55px 32px 49px',
        backgroundColor: '#329A77',
        color: '#fff',
        textAlign: 'center',
        '@media (max-width: 760px)': { minHeight: 0, padding: '32px 24px 44px' },
    },
    layout: { position: 'relative', maxWidth: 1442, margin: '0 auto' },
    sideImage: {
        position: 'absolute',
        top: 0,
        width: 325,
        height: 305,
        objectFit: 'cover',
        '@media (max-width: 1150px)': { width: '24%', height: 'auto' },
        '@media (max-width: 760px)': { display: 'none' },
    },
    leftImage: { left: 14 },
    rightImage: { right: 14 },
    copy: { position: 'relative', maxWidth: 500, margin: '0 auto' },
    logo: {
        display: 'block',
        width: 380,
        maxWidth: '100%',
        height: 'auto',
        margin: '0 auto 34px',
        '@media (max-width: 760px)': { display: 'block', width: '100%', maxWidth: 380 },
    },
    copyBlock: {
        fontSize: 23,
        fontWeight: 700,
        lineHeight: 1.2,
        '& p': { margin: 0 },
        '& h1': { fontSize: 68, lineHeight: 1.05 },
        '& h2': { fontSize: 40, lineHeight: 1.1 },
        '& h3': { fontSize: 30, lineHeight: 1.15 },
        '@media (max-width: 760px)': { fontSize: 17.25, '& h1': { fontSize: 51 }, '& h2': { fontSize: 30 }, '& h3': { fontSize: 22.5 } },
    },
    divider: { width: '70%', height: 0, color: 'inherit', background: 'transparent', opacity: 1, border: 0, borderTop: '2px solid currentColor', margin: '27px auto 33px', '@media (max-width: 760px)': { margin: '25px auto' } },
    signIn: { margin: '25px auto 0', fontSize: 20, fontWeight: 700 },
    signInButton: { padding: 0, border: 0, background: 'transparent', color: 'inherit', textDecoration: 'underline', font: 'inherit', cursor: 'pointer' },
    footnote: { maxWidth: 680, margin: '27px auto 0', fontSize: 18, lineHeight: 1.15, '@media (max-width: 760px)': { fontSize: 13 } },
}));

const PassportLanderHero = ({ data, skus, cartIconLabel, styling }) => {
    const classes = useStyles();
    const { loginByRedirect } = useAuth();
    const copyBlocks = data?.copy_block || [];
    const renderedBlocks = copyBlocks.map((block) => resolvePassportCopy(block, skus)).filter(Boolean);

    return (
        <section
            className={classes.hero}
            data-component="passportLanderHero"
            style={{ backgroundColor: styling?.merchanding_background_color || data?.background_color || '#329A77', color: styling?.merchandising_font_color || '#fff' }}
        >
            <div className={classes.layout}>
                {data?.desktop_left_image?.url && <img className={`${classes.sideImage} ${classes.leftImage}`} src={data.desktop_left_image.url} alt="" />}
                {data?.desktop_right_image?.url && <img className={`${classes.sideImage} ${classes.rightImage}`} src={data.desktop_right_image.url} alt="" />}
                <div className={classes.copy}>
                    {data?.celebrations_logo?.url && <img className={classes.logo} src={data.celebrations_logo.url} alt="Celebrations Passport" />}
                    {renderedBlocks.map((block, index) => (
                        <React.Fragment key={uid(block, index)}>
                            <div className={classes.copyBlock}>{ReactHtmlParser(block)}</div>
                            <hr className={classes.divider} />
                        </React.Fragment>
                    ))}
                    <PassportLanderCta skus={skus} cta={data?.cta} cartIconLabel={cartIconLabel} styling={styling} />
                    {data?.enrolled_path_copy && (
                        <p className={classes.signIn}>{data.enrolled_path_copy} <button className={classes.signInButton} type="button" onClick={() => loginByRedirect()}>Sign in</button></p>
                    )}
                    {data?.details_copy && <p className={classes.footnote}>{data.details_copy}</p>}
                </div>
            </div>
        </section>
    );
};

PassportLanderHero.propTypes = { data: shape({}), skus: object, cartIconLabel: string, styling: object };
PassportLanderHero.defaultProps = { data: {}, skus: {}, cartIconLabel: 'Cart', styling: {} };
export default PassportLanderHero;
